<template>
  <div v-if="isLogin && role!='org'"  class="headerRight">
    <div class="userMenu">
      <img :src="userInfo.avatar" class="userAvatar" />
      <span class="userName">{{userInfo.nickName}}</span>
      <img src="../../assets/icon_down.png" class="userIcon" />
      <div class="userList">
        <router-link :to="{path:'/user',query:{m:'profile'}}">个人信息</router-link>
        <router-link :to="{path:'/user',query:{m:'class'}}">我的课程</router-link>
        <router-link :to="{path:'/user',query:{m:'order'}}">我的订单</router-link>
        <router-link :to="{path:'/user',query:{m:'point'}}">我的学分</router-link>
        <a href="javascript:;" @click="signOut">退出登录</a>
      </div>
    </div>
  </div>
  <div v-if="isLogin && role =='org'"  class="headerRight">
    <div class="userMenu">
      <img :src="userInfo.orgInfo.logo" class="userAvatar" />
      <span class="userName">{{userInfo.orgInfo.name}}</span>
      <img src="../../assets/icon_down.png" class="userIcon" />
      <div class="userList">
        <router-link to="/organization/jbxx">基本信息</router-link>
        <router-link to="/organization/cwxx">财务信息</router-link>
        <router-link to="/organization/cklb">课程讲师列表</router-link>
        <router-link to="/organization/cjkc">创建课程</router-link>
        <router-link to="/organization/sxkc">已上线课程</router-link>
        <router-link to="/organization/kcpf">课程评分管理</router-link>
        <router-link to="/organization/kcjs">课程结算管理</router-link>
        <a href="javascript:;" @click="signOut">退出登录</a>
      </div>
    </div>
  </div>
  <div v-if=!isLogin class="signIn">
    <router-link class="loginBtn" to="/login">登录</router-link>
    <router-link class="registerBtn" to="/register">注册</router-link>
  </div>
</template>

<script>
import { requestToken, clearRequestToken,requestRole } from "../../common/js/request_token"
import { getUserInfo } from "../../server/user_center_info";

export default {
  data() {
    return {
      userInfo: {
        orgInfo:{}
      }
    }
  },
  mounted() {
    // 如果本地有token，则拉取用户信息，用于展示用户头像及用户名
    if (this.isLogin) {
      this.fetchUserInfo();
    }
    console.log('role',this.role);
    //Vue：外部js调用vue的methods中的方法
    // methods里面定义的方法, 需要赋值给window
    //第二步在需要被JS调用的地方调用(base.js)
    //这个主要是为了解决服务端cookie过期之后打开首页跳转到登录页问题，同事解决不再调转登录页后首页右上角显示问题
    window.signOut=this.signOut;
  },
  computed: {
    isLogin: {
      get() {
        return requestToken() !== "";
      }
    },
    role:{
      get(){
        return requestRole()
      }
    }
  },
  methods: {
    async fetchUserInfo() {
      let info = await getUserInfo();
      if (info != false) {
        this.userInfo = info;
        this.$store.commit('updateUserCenterInfo', info);
      } else {
        //解决token失效之后跳转到首页问题
        clearRequestToken();
      }
    },
    signOut() {
      clearRequestToken();
      console.log('退出登录A：',this.$route.path)
      console.log('退出登录B：',process.env.VUE_APP_BASE_PATH)
      // 刷新页面 或 跳转至首页
      if (this.$route.path == process.env.VUE_APP_BASE_PATH) {
        // 刷新当前页面
        this.$router.go(0);
      } else {
        // 跳转至首页
        this.$router.push('/home');
      }
    }
  },
};
</script>

<style spoed>
.headerRight {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.signIn {
  margin-top: 14px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.loginBtn {
  display: inline-block;
  width: 90px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border: 1px solid #003399;
  border-radius: 2px;
  color: #003399;
  font-size: 14px;
  margin-right: 10px;
}
.loginBtn:hover {
  background-color: #f0f0ff;
}
.registerBtn {
  display: inline-block;
  width: 90px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 2px;
  background-color: #003399;
  color: #fff;
  font-size: 14px;
}
.registerBtn:hover {
  background-color: var(--link-hover-color2);
}
.userMenu {
  display: inline-block;
  position: relative;
  z-index: 10;
  width: 150px;
  height: 64px;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 15px;
  border: 1px solid #fff;
  border-bottom: 0;
  border-radius: 4px 4px 0 0;
}
.userMenu .userAvatar {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: inline-block;
  margin-right: 12px;
}
.userMenu .userName {
  color: #151515;
  font-size: 14px;
  display: inline-block;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.userMenu .userIcon {
  display: inline-block;
  width: 14px;
  height: 9px;
}
.userMenu .userList {
  display: none;
  position: absolute;
  z-index: 11;
  left: -1px;
  right: -1px;
  top: 63px;
  background-color: #fff;
  border: 1px solid #ededed;
  border-top: 0;
  border-radius: 0 0 4px 4px;
  padding-left: 10px;
  padding-right: 10px;
}
.userMenu .userList a {
  display: block;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #151515;
  font-size: 14px;
  border-bottom: 1px solid #ececec;
}
.userMenu .userList a:last-child {
  border-bottom: 0;
}
.userMenu .userList a:hover {
  color: var(--link-hover-color);
}
.userMenu:hover {
  border-color: #ededed;
}
.userMenu:hover .userList {
  display: block;
}
</style>